var map = {
	"./NavIcon.svg": 950,
	"./add_icon.svg": 9709,
	"./arrow-left.svg": 6145,
	"./arrow_left.svg": 347,
	"./back-arrow.svg": 9855,
	"./bar1.svg": 4546,
	"./bar2.svg": 6289,
	"./bar3.svg": 1488,
	"./camera-scan.svg": 1231,
	"./check-small.svg": 3716,
	"./check.svg": 4414,
	"./close.svg": 8298,
	"./drop-arrow.svg": 4433,
	"./edit_pen.svg": 5738,
	"./eye_icon.svg": 5071,
	"./file_icon.svg": 7900,
	"./home_icon.svg": 7137,
	"./is_checked_icon.svg": 7548,
	"./lamp.webp": 3275,
	"./minus_icon.svg": 8174,
	"./plus-disabled.svg": 7899,
	"./plus.svg": 4034,
	"./room_icon.svg": 981,
	"./sample_lamp.svg": 153,
	"./scan_icon.svg": 2675,
	"./search_icon.svg": 2138,
	"./settings_icon.svg": 7299,
	"./square-error.svg": 6846,
	"./square-small.svg": 8505,
	"./square.svg": 7563,
	"./table_lamp.jpg": 2837,
	"./trash_icon.svg": 2096
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;